import React from 'react'
import JSZip from 'jszip';
import styles from './zip-button-file.module.scss'

export default function ZipButtonFile() {
    const handlerDownload = async () => {
        const zip = new JSZip();

        const cvPdf = await fetch('/assets/Currículo - Marcos Maio -  Eg.pdf') 
        const coursesPdf = await fetch('/assets/Certificates Courses.pdf')
        
        zip.file('Currículo - Marcos Maio -  Eg.pdf', await cvPdf.blob());
        zip.file('Certificates Courses.pdf', await coursesPdf.blob());
        
        const content = await zip.generateAsync({ type: 'blob' });

        const url = URL.createObjectURL(content);
        
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Cv and Courses - Marcos Maio.zip';
        link.click();

        URL.revokeObjectURL(url);
    
    };

    return (
        <>
            <button className={styles.buttonDownload} onClick={handlerDownload}>
                Download CV
            </button>
        </>
    )
}
